module.exports = __webpack_public_path__ + "static/media/2.542cc1cb.png";